import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/Kuddlecore-Logo.png";
import "../styles/TrustDevice.css";

const API_BASE = process.env.REACT_APP_API_BASE || "";

const getFriendlyDeviceName = (deviceLabel = "") => {
    const label = deviceLabel.toLowerCase();

    const browser = label.includes("edg")
        ? "Edge"
        : label.includes("chrome")
            ? "Chrome"
            : label.includes("safari")
                ? "Safari"
                : "Browser";

    const device = label.includes("windows")
        ? "Windows PC"
        : label.includes("mac")
            ? "Mac"
            : label.includes("iphone")
                ? "iPhone"
                : label.includes("android")
                    ? "Android Device"
                    : "Device";

    return `${device} • ${browser}`;
};

export default function TrustDevice() {
    const location = useLocation();
    const navigate = useNavigate();
    const { login } = useAuth();

    const {
        userId,
        email,
        deviceLabel,
        requiresTwoFactor,
    } = location.state || {};

    const handleTrust = async () => {
        try {
            const res = await axios.post(`${API_BASE}/api/auth/trust-device`, {
                userId,
            });

            localStorage.setItem("kuddleDeviceToken", res.data.deviceToken);

            if (res.data.requiresTwoFactor || requiresTwoFactor) {
                navigate("/verify-2fa", {
                    replace: true,
                    state: {
                        userId,
                        email,
                    },
                });
                return;
            }

            if (res.data.token && res.data.user) {
                login({
                    user: res.data.user,
                    token: res.data.token,
                });

                navigate("/", { replace: true });
                return;
            }

            navigate("/login", { replace: true });
        } catch (err) {
            console.error("Trust device error:", err);
            console.error("Failed to trust device");
        }
    };

    return (
        <div className="trust-device-page">
            <div className="trust-device-card">
                <img
                    src={logo}
                    alt="Kuddlecore Logo"
                    className="trust-device-logo"
                />

                <div className="trust-device-icon">🛡️</div>

                <h2 className="trust-device-title">Recognize This Device</h2>

                <p className="trust-device-subtitle">
                    This device isn't recognized yet.
                </p>

                <p className="trust-device-text">
                    Kuddlecore will remember this device for the next{" "}
                    <strong>30 days</strong>. You will still sign in with your
                    password, but you won't be asked to verify this device again
                    unless you remove it or the trust period expires.
                </p>

                {email && (
                    <div className="trust-device-note">
                        Your account for <strong>{email}</strong> will continue to
                        be protected by your password and two-factor authentication
                        if enabled.
                    </div>
                )}

                <div className="trust-device-info trust-device-grid">
                    <div>
                        <div className="trust-device-mini-icon">💻</div>
                        <div className="trust-device-name">Windows PC</div>
                        <span className="trust-device-label">Device</span>
                    </div>

                    <div>
                        <div className="trust-device-mini-icon">🌐</div>
                        <div className="trust-device-name">Chrome</div>
                        <span className="trust-device-label">Browser</span>
                    </div>

                    <div>
                        <div className="trust-device-mini-icon">📅</div>
                        <div className="trust-device-name">30 Days</div>
                        <span className="trust-device-label">Trusted for</span>
                    </div>
                </div>

                <button
                    type="button"
                    onClick={handleTrust}
                    className="trust-device-button"
                >
                    Remember This Device for 30 Days
                </button>

                <p className="trust-device-footer">
                    This does <strong>not</strong> keep you signed in for 30 days.
                    You can remove trusted devices at any time from the{" "}
                    <strong>Security Center</strong>.
                </p>
            </div>
        </div>
    );
}